import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import InfoIcon from "@mui/icons-material/Info";
import CloseIcon from "@mui/icons-material/Close";
import classes from "./ContactModal.module.scss";

const ContactModal = ({
  handleClose,
  open,
  title,
  text,
  buttonText = "Close",
  type = "info",
}) => {
  const Icon =
    type === "success"
      ? CheckCircleIcon
      : type === "error"
        ? ErrorIcon
        : InfoIcon;

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="contact-modal-title"
      aria-describedby="contact-modal-description"
      className={classes["modal"]}
      PaperProps={{
        className: classes["modal-paper"],
      }}
    >
      <button
        type="button"
        className={classes["close-btn"]}
        onClick={handleClose}
        aria-label="Close message"
      >
        <CloseIcon />
      </button>

      <DialogContent className={classes["modal-content"]}>
        <div className={`${classes["icon-wrap"]} ${classes[type]}`}>
          <Icon />
        </div>

        <h2 id="contact-modal-title">{title}</h2>

        <DialogContentText
          id="contact-modal-description"
          className={classes["modal-text"]}
        >
          {text}
        </DialogContentText>
      </DialogContent>

      <DialogActions className={classes["modal-actions"]}>
        <button type="button" onClick={handleClose}>
          {buttonText}
        </button>
      </DialogActions>
    </Dialog>
  );
};

export default ContactModal;
